/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rscu_col_codon = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codon`)
};

const es_rscu_col_codon = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codón`)
};

const de_rscu_col_codon = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codon`)
};

const nl_rscu_col_codon = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codon`)
};

const fr_rscu_col_codon = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codon`)
};

const it_rscu_col_codon = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codone`)
};

const pt_br2_rscu_col_codon = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Códon`)
};

const pt_rscu_col_codon = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codão`)
};

const ja_rscu_col_codon = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コドン`)
};

const zh_rscu_col_codon = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`密码子`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rscu_col_codon = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rscu_col_codon(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rscu_col_codon", locale)
	if (locale === "en") return en_rscu_col_codon(inputs)
	if (locale === "es") return es_rscu_col_codon(inputs)
	if (locale === "de") return de_rscu_col_codon(inputs)
	if (locale === "nl") return nl_rscu_col_codon(inputs)
	if (locale === "fr") return fr_rscu_col_codon(inputs)
	if (locale === "it") return it_rscu_col_codon(inputs)
	if (locale === "pt-BR") return pt_br2_rscu_col_codon(inputs)
	if (locale === "pt") return pt_rscu_col_codon(inputs)
	if (locale === "ja") return ja_rscu_col_codon(inputs)
	return zh_rscu_col_codon(inputs)
};